import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import FalconCloseButton from 'components/common/FalconCloseButton';

/**
 * Modal para confirmar la eliminación de una licencia de la orden
 */
const ModalEliminarLicencia = ({
    seguroStateEliminar,
    setseguroStateEliminar,
    cancelarLicenciaOrden
}) => {
    if (!seguroStateEliminar.isOpen) return null;

    return (
        <Modal
            show={true}
            onHide={() => setseguroStateEliminar({ isOpen: false, idLicencia: null, idOrdenDetalle: null })}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            top="top"
        >
            <Modal.Header>
                <Modal.Title>&iquest;Seguro?</Modal.Title>
                <FalconCloseButton
                    className="btn btn-circle btn-sm transition-base p-0"
                    onClick={() => setseguroStateEliminar({ isOpen: false, idLicencia: null, idOrdenDetalle: null })}
                />
            </Modal.Header>
            <Modal.Body className="text-dark fs-2">
                <Row className="mb-3">
                    <Col>
                        &iquest;Est&aacute;s <strong>seguro</strong> que deseas eliminar la asignaci&oacute;n de esta licencia a este detalle de la orden?
                    </Col>
                </Row>

                <Row>
                    <Col className="col-6">
                        <Button
                            onClick={() => cancelarLicenciaOrden(seguroStateEliminar.idLicencia, seguroStateEliminar.idOrdenDetalle)}
                            variant="primary"
                            className="col-12"
                        >
                            SI
                        </Button>
                    </Col>

                    <Col className="col-6">
                        <Button
                            onClick={() => setseguroStateEliminar({ isOpen: false, idLicencia: null, idOrdenDetalle: null })}
                            variant="danger"
                            className="col-12"
                        >
                            NO
                        </Button>
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer></Modal.Footer>
        </Modal>
    );
};

ModalEliminarLicencia.propTypes = {
    seguroStateEliminar: PropTypes.shape({
        isOpen: PropTypes.bool.isRequired,
        idLicencia: PropTypes.number,
        idOrdenDetalle: PropTypes.number
    }).isRequired,
    setseguroStateEliminar: PropTypes.func.isRequired,
    cancelarLicenciaOrden: PropTypes.func.isRequired
};

export default ModalEliminarLicencia;
